import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Seo from "@/components/Seo";

const PaymentCancelled = () => (
  <div className="bg-ivory min-h-[70vh]">
    <Seo title="Paiement annulé" description="Votre paiement a été annulé." path="/paiement-annule" noindex />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-28 text-center">
      <div className="w-20 h-20 mx-auto rounded-full bg-red-500/10 flex items-center justify-center mb-6">
        <XCircle size={44} className="text-red-500" />
      </div>
      <h1 className="font-heading text-3xl md:text-4xl font-light text-brown-black" data-testid="cancel-title">Paiement annulé</h1>
      <p className="text-brown-black/70 mt-3">Votre paiement n'a pas été finalisé. Aucun montant n'a été prélevé.</p>
      <p className="text-brown-black/60 mt-1">Votre panier est conservé, vous pouvez réessayer à tout moment.</p>
      <div className="flex flex-col sm:flex-row gap-3 justify-center mt-10">
        <Link to="/checkout" className="inline-flex items-center justify-center px-6 py-3 rounded-full bg-gold text-white font-semibold hover:bg-gold-light transition-colors" data-testid="cancel-retry">Réessayer le paiement</Link>
        <Link to="/boutique" className="inline-flex items-center justify-center px-6 py-3 rounded-full border border-gold text-gold font-semibold hover:bg-gold/10 transition-colors">Retour à la boutique</Link>
      </div>
    </div>
  </div>
);

export default PaymentCancelled;
